import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-property',
  templateUrl: './icon-property.component.html',
  styles: []
})
export class IconPropertyComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
